<template>
    <div>
        <zm-row>
            <time-picker-option @setTimeRange="setTimeRange"
                ref="timePickerOption"></time-picker-option>
            Level <zm-select v-model="filter.level" placeholder="level">
                <zm-option v-for="item in levelList" :key="item" :label="item" :value="item"></zm-option>
            </zm-select>
            Status <zm-select v-model="filter.status" placeholder="status">
                <zm-option v-for="item in statusList" :key="item" :label="item" :value="item"></zm-option>
            </zm-select>
            Metric <zm-select v-model="filter.metricName" placeholder="metricName" clearable filterable allow-create>
                <zm-option v-for="item in metricsList" :key="item" :label="item" :value="item"></zm-option>
            </zm-select>
            <zm-button @click="fetchData" type="icon" icon="zm-icon-search" :loading="loading"></zm-button>
        </zm-row>
        <zm-table :data="list" :init-displayed-column="initDisplayedColumn" v-loading="loading">
            <zm-table-column label="Name" prop="name" show-overflow-tooltip></zm-table-column>
            <zm-table-column label="Level" prop="level" width="100px"></zm-table-column>
            <zm-table-column label="LastCount" prop="lastCount" width="120px"></zm-table-column>
            <zm-table-column label="LastTime" prop="lastTime" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.lastTimeString }}
                </template>
            </zm-table-column>
            <zm-table-column label="MetricRecordTags" prop="MetricRecordTags">
                <template slot-scope="scope">
                    <zm-popover placement="bottom">
                        <div>
                            <span v-for="(i, index) in Object.keys(scope.row.metricRecord.tags)" :key="index">
                                <p>{{ i }}:{{ scope.row.metricRecord.tags[i] }}</p>
                            </span>
                        </div>
                        <zm-button type="icon" icon="zm-icon-eyes" slot="reference"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column label="MetricRecordFields" prop="MetricRecordFields">
                <template slot-scope="scope">
                    <zm-popover placement="bottom">
                        <div>
                            <span v-for="(i, index) in Object.keys(scope.row.metricRecord.fields)" :key="index">
                                <p>{{ i }}:{{ scope.row.metricRecord.fields[i] }}</p>
                            </span>
                        </div>
                        <zm-button type="icon" icon="zm-icon-eyes" slot="reference"></zm-button>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column label="Trigger Rule" prop="triggerRule">
                <template slot-scope="scope">
                    <zm-popover placement="bottom">
                        <div>
                            <span v-for="(i, index) in scope.row.triggerRule.items" :key="index">
                                <p>{{ i.name }}{{ i.operator }}{{ i.value }}</p>
                            </span>
                        </div>
                        <zm-tag slot="reference">{{ scope.row.triggerRule.level }}</zm-tag>
                    </zm-popover>
                </template>
            </zm-table-column>
            <zm-table-column label="Status" prop="status" width="150px">
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
    </div>
</template>
<script>
import {
    listRecord,
    listMetrics
} from '@/api/monitorManager'
import TimePickerOption from '@/components/TimeRangePicker/index'
export default {
    name: 'alarmRecord',
    components: { TimePickerOption },
    data () {
        return {
            initDisplayedColumn: {
                key: 'alarmrecord',
                props: ['name', 'lastCount', 'lastTime', 'level', 'MetricRecordTags', 'MetricRecordFields', 'triggerRule', 'status']
            },
            list: [],
            metricsList: [],
            loading: false,
            visible: false,
            levelList: ['FATAL', 'ERROR', 'WARN', 'OK'],
            statusList: ['SILENCE', 'OPENED', 'CLOSED'],
            typeList: ['IM', 'Webhook', 'Email', 'Incident'],
            filter: {
                from: '',
                to: '',
                level: null,
                metricName: null,
                status: null
            },
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            timeZone: 0,
            showTimeZone: 0
        }
    },
    created () {
        // this.fetchData()
        this.fetchMetrics()
        this.timeZone = -(new Date()).getTimezoneOffset() / 60
        this.showTimeZone = this.timeZone
    },
    methods: {
        setTimeRange (val, timeZone) {
            this.timeZone = timeZone
            this.filter.from = val[0]
            this.filter.to = val[1]
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        fetchData () {
            this.loading = true
            const { size, page } = this.pageable
            const { from, to, level, metricName, status } = this.filter
            const data = {
                from, to, level, metricName, status, size, page: page - 1
            }
            listRecord(data).then(response => {
                this.showTimeZone = this.timeZone
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchMetrics () {
            if (!this.metricsList.length) {
                listMetrics().then(response => {
                    this.metricsList = response
                })
            }
        }
    }
}
</script>
